/**
 * backgroundSession — keeps sessions running when the phone screen locks.
 * Web: sets Media Session metadata (lockscreen info in Chrome).
 * Native (Capacitor): starts an Android foreground service so the system
 * never suspends the WebView while a session or ambient sound is playing.
 */
import { Capacitor } from '@capacitor/core';

let activeCount = 0;
let serviceRunning = false;
const isNative = Capacitor.isNativePlatform();

async function getPlugin() {
  const mod = await import('@capawesome-team/capacitor-android-foreground-service');
  return mod.ForegroundService;
}

export async function startBackgroundSession(label) {
  activeCount++;
  if (typeof navigator !== 'undefined' && 'mediaSession' in navigator) {
    try {
      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: label,
        artist: 'Hypnose clé'
      });
    } catch (_) {}
  }
  if (!isNative || serviceRunning) return;
  try {
    const ForegroundService = await getPlugin();
    try { await ForegroundService.requestPermissions(); } catch (_) {}
    await ForegroundService.startForegroundService({
      id: 1234,
      title: 'Hypnose clé',
      body: label,
      smallIcon: 'ic_stat_zen'
    });
    serviceRunning = true;
  } catch (e) {
    console.warn('Service arrière-plan indisponible:', e?.message || e);
  }
}

export async function stopBackgroundSession() {
  activeCount = Math.max(0, activeCount - 1);
  if (activeCount > 0) return;
  if (!isNative || !serviceRunning) return;
  serviceRunning = false;
  try {
    const ForegroundService = await getPlugin();
    await ForegroundService.stopForegroundService();
  } catch (_) {}
}
